import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../Config'; // o '../Config' si el path cambia
import { useNavigate } from 'react-router-dom';

const DescuentoAdmin = () => {
  const [descuentos, setDescuentos] = useState([]);
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resDescuentos, resProductos] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/descuentos`),
          axios.get(`${API_BASE_URL}/api/productos`)
        ]);
        setDescuentos(resDescuentos.data);
        setProductos(resProductos.data);
        setCargando(false);
      } catch (err) {
        console.error(err);
        setError('Error al cargar datos');
        setCargando(false);
      }
    };

    fetchData();
  }, []);

  const mapaProductos = productos.reduce((map, prod) => {
    map[prod.id] = prod.nombre;
    return map;
  }, {});

  const manejarAgregar = () => {
    navigate('/registro-descuento');
  };

  const manejarEditar = (id) => {
    navigate(`/editar-descuento/${id}`);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-4xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Listado de Descuentos</h2>
          <button
            onClick={manejarAgregar}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            + Agregar Descuento
          </button>
        </div>

        {cargando ? (
          <p className="text-gray-600">Cargando descuentos...</p>
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : (
          <table className="w-full table-auto border">
            <thead className="bg-gray-200 text-left">
              <tr>
                <th className="p-2 border">ID</th>
                <th className="p-2 border">Producto</th>
                <th className="p-2 border">Porcentaje</th>
                <th className="p-2 border">Fecha</th>
                <th className="p-2 border">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {descuentos.map((desc) => (
                <tr key={desc.idDescuento} className="hover:bg-gray-100">
                  <td className="p-2 border">{desc.idDescuento}</td>
                  <td className="p-2 border">{mapaProductos[desc.productoId] || `ID ${desc.productoId}`}</td>
                  <td className="p-2 border">{desc.porcentajeDescuento}%</td>
                  <td className="p-2 border">{desc.fecha}</td>
                  <td className="p-2 border">
                    <button
                      onClick={() => manejarEditar(desc.idDescuento)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default DescuentoAdmin;
